<div class="widget-inner-alert_wrapper">

  <div class="widget-inner-alert_title">
    {{title | l10n}}
  </div>

  <div class="widget-inner-alert_body">
    @for (error of twapAlgoParamsErrors; track error) {
      @switch (error) {
        @case (TwapAlgoParamsError.TWAP_TIME_IS_INVALID) {
          {{'components.widgets.trade-widget.twap_time_error_message' | l10n:messageTranslationParams}}
        }
        @default {
          {{'components.widgets.trade-widget.common_error_message' | l10n:messageTranslationParams}}
        }
      }
    }
  </div>

  <button type="submit" class="widget-inner-alert_button" (click)="close()">
    {{buttonText | l10n}}
  </button>

  <svg class="widget-inner-alert_close" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
